import { Typography } from "@mui/material";
import { SearchableDropdown } from "../../components/SearchableDropdown";
import { QuestionChoice } from "../../models/types";

type SingleDropdownCustomFieldProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  choices?: string[] | QuestionChoice[];
  disabled?: boolean;
};

export const SingleDropdownCustomField = (props: SingleDropdownCustomFieldProps) => {
  const { value, onChange, choices: _choices, disabled } = props;
  const choices: string[] =
    !_choices || _choices.length === 0
      ? []
      : typeof _choices[0] === "string"
      ? (_choices as string[])
      : (_choices as QuestionChoice[]).map((c) => c.label);

  return choices && choices.length > 0 ? (
    <SearchableDropdown<string>
      value={value}
      onChange={(v) => (v ? onChange(v) : onChange(null))}
      getOptions={(search: string) =>
        choices?.filter((option) => option?.includes(search.toLowerCase())) ?? []
      }
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(a, b) => a === b}
      disabled={disabled}
    />
  ) : (
    <Typography variant="body2">Missing choices</Typography>
  );
};
